import * as selectors from './selectors';

export const CLEAR_TREEPICKER = 'CLEAR_TREEPICKER';
export const UPDATE_PARENT = 'TREEPICKER_UPDATE_PARENT';
export const SELECT_NODE = 'TREEPICKER_SELECT_NODE';
export const INIT_TREEPICKER = 'INIT_TREEPICKER';

export const clearTreePicker = () => {
  return {
    type: CLEAR_TREEPICKER,
  };
};

export const updateParent = parentId => {
  return {
    type: UPDATE_PARENT,
    parentId,
  };
};

export const selectNode = nodeId => ({
  type: SELECT_NODE,
  nodeId,
});

export const handleSelect = nodeId => dispatch => {
  dispatch(updateParent(nodeId));
  dispatch(selectNode(nodeId));
};

export const handleInitTreePicker = tree => {
  return {
    type: INIT_TREEPICKER,
    tree,
  };
};

export const initTreePicker = property => (dispatch, getState) => {
  const tree = selectors.selectTree(getState(), property);

  dispatch(handleInitTreePicker(tree));
};
